import Confetti from './Confetti.vue'
import Logo from './Logo.vue'

export default {
    'tl-confetti': Confetti,
    'tl-logo': Logo,
}
